import React, { Component } from 'react'

function withNotifications(WrappedComponent) {
  class Notifications extends Component {
    success = content => {
      this.sendMessage({
        variant: 'green',
        sticky: false,
        viewLinkTo: null,
        content,
      })
    }

    error = content => {
      this.sendMessage({
        variant: 'red',
        sticky: false,
        viewLinkTo: null,
        content,
      })
    }

    sendMessage(settings) {
      this.app.actions.NotificationActions.pushNotification(settings)
    }

    render() {
      const { success, error } = this
      return <WrappedComponent {...this.props} notifications={{ success, error }} />
    }
  }

  return Marty.createContainer(Notifications)
}

export default withNotifications



// WEBPACK FOOTER //
// ./src/scripts/components/shared/notifications/index.js